

import ruleOffLine from "@/components/rule/offLine";
import rulePoint from "@/components/rule/rulePoint";
import ruleFence from "@/components/rule/ruleFence";
import ruleLine from "@/components/rule/ruleLine";
import ruleCount from "@/components/rule/ruleCount";
import ruleSpeed from "@/components/rule/ruleSpeed";
import ruleNotice from "@/components/rule/ruleNotice";
import ruleStay from "@/components/rule/ruleStay";
import rulePost from "@/components/rule/post";
import ruleFatigue from "@/components/rule/fatigue";
import ruleMidNight from "@/components/rule/ruleMidNight";
var data = [
  {
    path: "/rulePushNotice",
    component: () => import("@/components/rule/rulePushNotice")
  },
  {
    path: "/rulePushAlarm",
    component: () => import("@/components/rule/rulePushAlarm")
  },
  {
    path: "/offLine",
    component: ruleOffLine
  },
  {
    path: "/ruleMidNight",
    component: ruleMidNight
  },
  {
    path: "/rulePoint",
    component: rulePoint
  },
  {
    path: "/ruleLine",
    component: ruleLine
  },
  {
    path: "/ruleFence",
    component: ruleFence
  },
  {
    path: "/ruleSpeed",
    component: ruleSpeed
  },
  {
    path: "/ruleCount",
    component: ruleCount
  },
  {
    path: "/ruleNotice",
    component: ruleNotice
  },
  {
    path: "/ruleStay",
    component: ruleStay
  },
  {
    path: "/post",
    component: rulePost
  },
  {
    path: "/fatigue",
    component: ruleFatigue
  },
  /*   {
    path: "/rule/gaofeng",
    component: () => import("@/components/rule/ruleGaofeng")
  } */
];
export default data;



// WEBPACK FOOTER //
// ./src/router/rule.js